export const POLL_INTERVALS = {
  schedulerStatus: 30_000,
  conversionsSync: 5_000,
  // Cadence accélérée quand un run est en cours, pour voir la fin du cycle sans attendre 30 s.
  schedulerStatusActive: 5_000,
  overview: 5 * 60_000,
  accountsHealth: 60_000,
} as const;

export const STALE_TIMES = {
  short: 30_000,
  medium: 60_000,
  long: 2 * 60_000,
  veryLong: 5 * 60_000,
  indefinite: 10 * 60_000,
} as const;

export const GC_TIMES = {
  default: 5 * 60_000,
  long: 10 * 60_000,
  veryLong: 15 * 60_000,
  indefinite: 30 * 60_000,
} as const;

export const PAGINATION = {
  defaultSize: 50,
  reelsPageSize: 30,
  schedulerRunsPageSize: 20,
  pageSizeOptions: [25, 50, 100],
} as const;

/**
 * Valeurs par défaut pour les endpoints analytics. Doivent rester alignées avec
 * les @RequestParam(defaultValue = ...) côté backend (cf. AnalyticsController).
 * Typé en `Record<string, number>` pour éviter les literal-types qui cassent
 * les signatures `(periodDays = X: number)`.
 */
export const ANALYTICS_DEFAULTS: Record<string, number> = {
  topAccountsLimit: 20,
  topAccountsPeriodDays: 7,
  overviewPeriodDays: 30,
  linkReadinessPeriodDays: 14,
  linkReadinessLimit: 50,
  retirementMinAgeDays: 30,
  retirementDailyAvgThreshold: 100,
  retirementPeriodDays: 14,
  retirementLimit: 50,
  efficiencyPeriodDays: 30,
  efficiencyLimit: 50,
  viralPeriodDays: 30,
  viralLimit: 50,
  templatesLimit: 100,
};

/**
 * Limite mensuelle RapidAPI (plan actuel). Hardcodé tant que le backend n'expose pas
 * `x-ratelimit-requests-limit` dans /scheduler/status — à câbler sur le DTO si jamais
 * on change de plan.
 */
export const RAPIDAPI_QUOTA_MAX = 20_000;

export const REFRESH_TOKEN_STORAGE_KEY = 'ig_refresh_token';

const ALL_TIME_PERIOD_OPTION = { value: 0, label: 'All time', labelEn: 'All time' } as const;

export const PERIOD_DAYS_OPTIONS = [
  { value: 7, label: '7 jours', labelEn: '7 days' },
  { value: 30, label: '30 jours', labelEn: '30 days' },
  { value: 90, label: '90 jours', labelEn: '90 days' },
  ALL_TIME_PERIOD_OPTION,
] as const;

export const VIRAL_PERIOD_OPTIONS = [
  { value: 1, label: '24 h', labelEn: '24 h' },
  { value: 7, label: '7 jours', labelEn: '7 days' },
  { value: 30, label: '30 jours', labelEn: '30 days' },
  ALL_TIME_PERIOD_OPTION,
] as const;

// ─── Templates ──────────────────────────────────────────────────────────────

export const TEMPLATE_PERIOD_OPTIONS = PERIOD_DAYS_OPTIONS;

export const TEMPLATE_MIN_REELS = 3;

export const TEMPLATE_SORT_OPTIONS = [
  { value: 'MEDIAN_VIEWS', label: 'Vues médianes', labelEn: 'Median views' },
  { value: 'MAX_VIEWS', label: 'Meilleur reel', labelEn: 'Best reel' },
  { value: 'REEL_COUNT', label: 'Nombre de reels', labelEn: 'Reel count' },
  { value: 'VIRAL_RATE', label: 'Taux viral', labelEn: 'Viral rate' },
  { value: 'LAST_PUBLISHED_AT', label: 'Plus récent', labelEn: 'Most recent' },
] as const;
